<template>
<div class="tracking-content-wrapper">
    <h1 class="mob-title-wrapper">郵件狀態查詢</h1>
    <div class="content">
        <table class="table-order">
            <tr style="display: none;">
                <th colspan="2">
                    <span class="text-red">
                        國內掛號及包裹資料更新時間為每日早上6點5分、早上10點5分至晚上12點5分每小時更新1次，更新時間約為5~10分鐘，敬請避開上述時段查詢。
                    </span>
                </th>
            </tr>
            <tr>
                <th colspan="2">
                    請輸入國內快捷、掛號、包裹郵件號碼(14碼或20碼)：
                    <br>
                    大宗掛號函件、包裹查詢請輸入「6碼郵件掛號號碼」+「6碼收寄局碼」+「2碼郵件類別碼」
                </th>
            </tr>
            <tr>
                <th class="text-right">郵件號碼：</th>
                <td>
                    <dx-text-box class="custom-input" width="100%" :value.sync="queryCondition['PostNo']"></dx-text-box>
                </td>
            </tr>
            <tr>
                <th class="text-right">圖形驗證碼：</th>
                <td class="verify-field">
                    <dx-text-box class="custom-input" :value.sync="verifycode"></dx-text-box>
                    <div class="coderight">
                        <SIdentify :identifyCode="identifyCode" @click="refreshCode"></SIdentify>
                    </div>
                    <dx-button type="default" text="重新產生驗證碼" @click="refreshCode" />
                </td>
            </tr>
        </table>
        <div class="order-search-wrapper">
            <dx-button type="default" class="btn-main" text="查詢" @click="queryData" />
        </div>
        <table class="table-order">
            <tr>
                <th colspan="4" class="text-center">
                    <span class="text-red">
                        目前最新處理結果
                    </span>
                </th>
            </tr>
            <tr>
                <th>郵件號碼</th>
                <th>狀態</th>
                <th>處理日期時間</th>
                <th>處理單位</th>
            </tr>
            <tr v-for="(data,index) in tableData" :key="index">
                <td>
                    {{data.postno}}
                </td>
                <td>
                    {{data.deliverystatename}}
                </td>
                <td>
                    {{data.updtime}}
                </td>
                <td>
                    {{data.postofficename}}
                </td>
            </tr>
        </table>
        <div class="order-search-wrapper">
        </div>
        <div class="explain-wrapper">
            說明：
            <ol>
                <li>
                    本系統僅提供最近國內快捷6個月，國內普通掛號/限時掛號/包裹3個月內之相關郵件處理結果查詢。
                </li>
                <li>
                    若超過提供期限查無郵件處理資訊，請備妥相關執據(郵件編號及收、寄件人詳細資料)，自交寄之次日起六個月內逕洽原收寄郵局辦理書面查詢。
                </li>
                <li>
                    如須大量查詢郵件投遞資訊，可利用本公司「郵件查詢網路介接服務」，相關申請書 及 服務說明 ，可連結後下載，並送相關單位申請即可。
                </li>
            </ol>
            注意事項：
            <ol>
                <li>
                    國內掛號函件全部遺失或被竊、國內包裹及快捷郵件全部或部分遺失、被竊或毀損，依法得予補償者，掛號函件每件575元、包裹及快捷郵件每件最低575元，最高1155元。
                </li>
                <li>
                    貴重物品及重要文件請按報值或保價交寄。報值或保價郵件遇有遺失、被竊或毀損依法應予補償時，按所報或所保價值之全部或一部予以補償，報值最高不逾5萬元，保價最高不逾10萬元。
                </li>
                <li>
                    如須索取購買票品證明單者，請當場申請，事後不予補證。
                </li>
                <li>
                    寄件人應依規定交寄郵件，不得裝寄危險或禁寄物品，違反規定者，寄件人並應負全部責任。
                </li>
            </ol>
        </div>

    </div>
</div>
</template>

<script>
import axios from "axios";
import DxButton from "devextreme-vue/button";
import DxTextBox from "devextreme-vue/text-box";
import SIdentify from "../components/identify";
import notify from 'devextreme/ui/notify';
import {
    FormHService
} from "../services/FormHService";
const formHService = new FormHService();

export default {
    data() {
        return {
            verifycode: "",
            identifyCode: '',
            programNo: "WSSM0500", //程式代碼
            queryCondition: {}, //查詢條件
            tableData: [],
        };
    },
    mounted() {
        this.identifyCode = "";
        this.makeCode(this.identifyCodes, 4);
    },
    methods: {
        refreshCode() {
            this.identifyCode = "";
            this.makeCode(this.identifyCodes, 4);
        },
        randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },
        makeCode(o, l) {
            for (let i = 0; i < l; i++) {
                let t = this.randomNum(0, 9);
                this.identifyCode += t;
            }
        },
        queryData() {

            if (this.verifycode != this.identifyCode) {
                notify("驗證碼錯誤", "error");
                return;
            }
            
            /*axios.defaults.headers.common['Authorization'] = 'Bearer WSS';*/
            let conditions = JSON.stringify(this.queryCondition);
            formHService
                .trackPackQuery(this.programNo, conditions)
                .then((res) => {
                    this.tableData = res.data.Data;
                })
                .catch((error) => {
                    if (error.response) {
                        notify(error.response.data.message, "error", 600);
                    } else {
                        notify("資料服務無回應或離線", "error", 600);
                    }
                    this.loading = false;
                });
        }
    },
    components: {
        DxButton,
        DxTextBox,
        SIdentify
    },
};
</script>
